module.exports = __webpack_public_path__ + "img/article610.ea673ce3.jpg";